// Сортировка с учётом правил русского языка и корректным порядком чисел внутри строк («1а» < «11а»)
const collator = new Intl.Collator('ru', { numeric: true, sensitivity: 'base' })

const startsWithDigit = (value: string) => /^\d/.test(value)

/** Сортировка по title по возрастанию: сначала пункты, начинающиеся на цифру, затем остальные по алфавиту. */
export const sortByTitle = <T extends { title: string }>(items: Array<T>): Array<T> =>
  [...items].sort((a, b) => {
    const aDigit = startsWithDigit(a.title)
    const bDigit = startsWithDigit(b.title)
    if (aDigit !== bDigit) return aDigit ? -1 : 1
    return collator.compare(a.title, b.title)
  })

export const emptyArray = []
